<template>
  <v-timeline-item color="action" icon="timeline" fill-dot small>
    <v-card>
      <v-card-title class="title font-weight-light theme-text pt-2 pb-0">{{data.title}}
        <v-spacer/>
        <span class="grey--text text--darken-2 text-body-2">{{ data.date }}</span>
      </v-card-title>
      <v-card-text class="py-0">
        <v-list two-line>
          <template v-for="item in data.data">
            <v-list-item :key="item.id">
              <v-list-item-avatar v-if="item.type==='timeoff'">
                <v-img :src="item.url"></v-img>
              </v-list-item-avatar>
              <v-list-item-avatar v-else-if="item.type==='holiday'">
                <v-icon class="theme" dark>beach_access</v-icon>
              </v-list-item-avatar>
              <v-list-item-avatar v-else>
                <v-img v-if="item.url" :src="item.url"/>
                <v-icon v-else large>account_circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
                <v-list-item-subtitle v-text="item.date"></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="item.description">
                <v-btn icon>
                  <v-icon color="pink darken-4">{{ getIconForDescription(item) }}</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'TimelineRegular',
  props: ['data'],
};
</script>

<style scoped>

</style>